<div nz-row class="min-h-[100vh]">
  <div nz-col nzSpan="11" class="py-10 px-10">
    <!-- <p class="font-normal text-5xl text-title " [ngStyle]="{'line-height.px': 62}">
      Welcome to the <span class="text-primary-500">SON</span> Factory Database
    </p>

    <p class="italic text-[#2D2D2D] mt-10 text-xl">The Apex Standardisation Body In Nigeria</p>

    <svg-icon src="assets/svgs/auth-image.svg"></svg-icon> -->

    <div
      class="w-full h-full bg-gradient-to-tr from-[#026225] to-[#0B4B23] rounded-2xl overflow-hidden relative flex items-center justify-center">

      <svg-icon src="assets/svgs/dashed-ellipse.svg" class="absolute top-0 left-0"></svg-icon>
      <svg-icon src="assets/svgs/dashed-ellipse-2.svg" class="absolute top-0 right-0"></svg-icon>

      <div class="w-[506px] text-center flex flex-col items-center justify-center gap-3 -top-14 relative">
        <p class="font-semibold text-[40px] text-white">Welcome to the <span class="text-[#0FFF67]">SON</span> Factory
          Database</p>

        <p class="text-[24px] text-white">The Apex Standardisation Body in Nigeria</p>

        <div class="relative w-[394px] mt-7">
          <div
            class="absolute w-[360px] h-[146px] rounded-2xl bg-white border shadow-[0px_20px_40px_0px_rgba(184,184,184,0.25)] z-[40] top-0 left-0">
          </div>

          <div
            class="absolute w-[360px] h-[146px] rounded-2xl bg-white border shadow-[0px_20px_40px_0px_rgba(184,184,184,0.25)] z-[50] top-3 left-3">
          </div>

          <div
            class="absolute w-[360px] h-[146px] rounded-2xl bg-white border shadow-[0px_20px_40px_0px_rgba(184,184,184,0.25)] z-[60] top-6 left-6 p-5 text-left space-y-4">
            <div class="flex gap-3 items-center w-full">
              <svg-icon src="assets/svgs/unspecified-factory-status.svg"></svg-icon>

              <div>
                <p class="font-semibold text-[20px] text-[#021605]">Welcome Back</p>
                <p class="text-sm text-[#5F6368]">Access your standardisation tools and factory data</p>
              </div>
            </div>

            <p class="text-[#5F6368] text-sm">3 new factory registrations this week</p>
          </div>
        </div>
      </div>

      <img [ngSrc]="'/assets/images/tree-shape.png'" alt="" width="416" height="482"
        [ngClass]="{ 'w-[905px] h-[647px] opacity-5 rotate-[-20.54deg] left-[-314px] bottom-[-300px] absolute z-10': true }"
        priority />
    </div>
  </div>

  <div nz-col nzSpan="13" class="bg-white py-4 px-4 flex justify-center items-center">
    <div [ngClass]="{
        'shadow-[0px_20px_40px_0px_rgba(177,177,177,0.25)] w-full max-w-[667px] mx-auto p-6 border border-[#f1f1f1] rounded-2xl bg-white md:px-4 lg:px-6 px-2': true
      }">
      <div [ngClass]="{ 'flex justify-center': true }">
        <img [ngSrc]="'/assets/images/son_logo.png'" alt="" width="75" height="75"
          [ngClass]="{ 'w-[75px] h-[75px]': true }" priority />
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>


</div>